import { DICTONARY } from 'const/Dictonary';
import { useMedia } from 'react-use';

export const useResponsive = customMediaQuery => {
  const isSMDown = useMedia(DICTONARY.RESPONSIVE_BREAKPOINT.SM);
  const isMDDown = useMedia(DICTONARY.RESPONSIVE_BREAKPOINT.MD);
  const isLGDown = useMedia(DICTONARY.RESPONSIVE_BREAKPOINT.LG);
  const customBreakPoint = useMedia(
    customMediaQuery || DICTONARY.RESPONSIVE_BREAKPOINT.MD
  );

  return {
    isMDDown,
    isLGDown,
    customBreakPoint
  };
};
